export const SET_SELECTED_COURSE_ID = 'SET_SELECTED_COURSE_ID';
export const SET_SELECTED_BOOK_ID = 'SET_SELECTED_BOOK_ID';
export const SET_SELECTED_BULLET_ID = 'SET_SELECTED_BULLET_ID';
export const GET_BOOKMARK_SUCCESS = 'GET_BOOKMARK_SUCCESS';
export const UPDATE_VIDEO_IN_FAVORITE_LIST = 'UPDATE_VIDEO_IN_FAVORITE_LIST';
export const ADD_VIDEO_TO_FAVORITE_LIST_SUCCESS = 'ADD_VIDEO_TO_FAVORITE_LIST_SUCCESS';
